<template>
  <div
    class="personal-information cac-input-wrapper__list-group">
    <advocate-badge v-if="showAdvocateBadge"/>
    <div
      v-else
      @focusin.once="startFillingForm"
    >
      <div class="cac-input-wrapper__list-group-container">
        <!-------- Honey -------->
        <component
          v-show="false"
          :is="fieldGroupTag"
          class="p2a-fieldset-zipcode field-group"
        >
    
          <label 
            for="input-zipcode" 
            class="p2a-input-label">
            <input
              id="input-zipcode"
              :name="'zip_code'"
              v-model="honeypotZipcode"
              autocomplete="off"
              type="text"
              @blur.native="blurField(formFields.zipcode, $event)"
            >
          </label>
        </component>
  
        <component
          v-show="false"
          :is="fieldGroupTag"
          class="p2a-fieldset-address field-group"
        >
          <label 
            for="input-address" 
            class="p2a-input-label">
            <input
              id="input-address"
              :name="'address'"
              v-model="honeypotAddress"
              autocomplete="off"
              type="text"
              @blur.native="blurField(formFields.address, $event)"
            >
          </label>
        </component>
        <div class="personal-information__name row align-items-end">
          <div
            v-if="optionalFields.title"
            class="col-md-6 col-lg-3 cac-input-wrapper__list-group--item cac-input-wrapper__list-group--first"
          >
            <cac-input-wrapper
              :title="$t('cac.app.title')"
              for="personal-information__title"
              class="mr-md-2">
              <cac-select
                id="personal-information__title"
                :options="titleOptions"
                v-model="title"
                :name="formHelper.getFieldName(formFields.title)"
                :show-placeholder="false"
                class="personal-information--input cac-select--small"
                @blur.native="blurField(formFields.title, $event)"/>
            </cac-input-wrapper>
          </div>
          <div
            :class="optionalFields.title ? 'col-md-12 col-lg-6' : 'cac-input-wrapper__list-group--first col-md-18 col-lg-7'"
            class="cac-input-wrapper__list-group--item"
          >
            <cac-input-wrapper
              :title="$t('cac.app.legal_first_name')"
              for="personal-information__first-name"
              class="mr-lg-2">
              <input
                id="personal-information__first-name"
                v-model="firstName"
                :name="formHelper.getFieldName(formFields.firstName)"
                class="personal-information--input"
                type="text"
                @blur="blurField(formFields.firstName, $event)"
              >
            </cac-input-wrapper>
          </div>
          <div
            :class="{ 'col-lg-8': !optionalFields.title }"
            class="col-md-12 col-lg-6 cac-input-wrapper__list-group--item">
            <cac-input-wrapper
              :title="$t('cac.app.last_name')"
              for="personal-information__last-name"
              class="mr-md-2">
              <input
                id="personal-information__last-name"
                v-model="lastName"
                :name="formHelper.getFieldName(formFields.lastName)"
                class="personal-information--input"
                type="text"
                @blur="blurField(formFields.lastName, $event)"
              >
            </cac-input-wrapper>
          </div>
          <div class="col-md-6 col-lg-3 cac-input-wrapper__list-group--item">
            <cac-input-wrapper
              :title="$t('cac.app.suffix')"
              for="personal-information__suffix">
              <cac-select
                id="personal-information__suffix"
                :options="suffixOptions"
                v-model="suffix"
                :name="formHelper.getFieldName(formFields.suffix)"
                :show-placeholder="false"
                class="personal-information--input cac-select--small"
              />
            </cac-input-wrapper>
          </div>
        </div>
        <div class="personal-information__address cac-input-wrapper__list-group--item">
          <cac-input-wrapper
            :title="$t('cac.app.street_address')"
            for="personal-information__address">
            <input
              id="personal-information__address"
              v-model="address"
              :name="formHelper.getFieldName(formFields.address1)"
              class="personal-information--input"
              type="text"
              placeholder=""
              @blur="delayAddressBlurField()"
            >
          </cac-input-wrapper>
        </div>
        <div class="personal-information__zip cac-input-wrapper__list-group--item">
          <cac-input-wrapper
            :title="$t('cac.app.zipcode')"
            for="personal-information__zip">
            <input
              id="personal-information__zip"
              v-model="zip"
              :name="formHelper.getFieldName(formFields.zip5)"
              class="personal-information--input"
              type="text"
              @blur="blurField(formFields.zip5, $event, true)"
            >
          </cac-input-wrapper>
        </div>
        <div
          v-if="optionalFields.email"
          class="personal-information__email cac-input-wrapper__list-group--item">
          <cac-input-wrapper
            :title="$t('cac.app.email_address')"
            for="personal-information__email">
            <input
              id="personal-information__email"
              v-model="email"
              class="personal-information--input"
              type="text"
              @blur="blurField(formFields.email, $event)"
            >
          </cac-input-wrapper>
        </div>
        <div
          v-if="optionalFields.phone"
          class="personal-information__phone cac-input-wrapper__list-group--item cac-input-wrapper__list-group--last">
          <cac-input-wrapper
            :title="$t('cac.app.phone_number')"
            for="personal-information__phone">
            <input
              id="personal-information__phone"
              v-model="phone"
              class="personal-information--input"
              type="text"
              @blur="blurField(formFields.phone, $event)"
            >
          </cac-input-wrapper>
        </div>
      </div>
      
      <custom-fields/>
      
      <div
        v-if="showSubscribeCheckboxes"
        class="mt-4">
        <div
          v-if="showSubscribeEmail"
          class="mb-2"
        >
          <input
            id="subscribeEmail"
            v-model="subscribeEmail"
            type="checkbox"
            class="input-checkbox"
          >
          <label
            for="subscribeEmail"
            class="input-checkbox__label">{{ $t('cac.app.subscribe_to_email_updates') }}</label>
        </div>
        <div v-if="showSubscribeSMS">
          <input
            id="subscribeSms"
            v-model="subscribeSms"
            type="checkbox"
            class="input-checkbox"
          >
          <label
            for="subscribeSms"
            class="input-checkbox__label">{{ $t('cac.app.subscribe_to_text_updates') }}</label>
        </div>
      </div>
      
      <div
        v-if="showSubscribeCheckboxes"
        class="register-btn pb-2 pt-4">
        <button
          :disabled="hasError"
          type="submit"
          class="btn btn--primary"
          @click.prevent="submitInformation()">
          <div
            v-if="loading"
            class="spinner-border"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <template v-else>{{ registerBtnText }}</template>
        </button>
      </div>
      
      <div
        v-if="showSubscribeCheckboxes"
        class="privacy-policy">
        <a
          :href="privacyPolicyUrl"
          target="_blank">{{ privacyPolicyUrlLabel }}</a>
      </div>
    </div>
  </div>
</template>

<script>
// VueX
import { mapActions, mapGetters, mapState } from "vuex";

// Constants
import STATE from "Constants/campaign/civicactioncenter/state";
import RouteNames from "Constants/campaign/civicactioncenter/routeNames";
import PersonalInformation from "Constants/campaign/civicactioncenter/personalInformation";
import * as HOME_BUTTON_LABELS from "Constants/campaign/civicactioncenter/homeButtonLabels";

// Mixins
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";
import GoogleMapsAutocompleteMixin from "JS/mixins/campaign/maps/googleMapsAutocomplete";

// CAC Components
import CacSelect from "CivicActionCenterComponents/utilities/CACSelect.vue";
import CacInputWrapper from "CivicActionCenterComponents/utilities/CACInputWrapper.vue";
import CustomFields from "CivicActionCenterComponents/shared/PersonalInformation/CustomFields.vue";
import AdvocateBadge from "CivicActionCenterComponents/sections/Home/AdvocateBadge.vue";

// Helpers
import VueValidatorHelper from "JS/helpers/vueValidator";
import ValidationHelper from "JS/helpers/civicactioncenter/validation";

import {
  isEmpty as _isEmpty,
  values as _values,
  compact as _compact,
  capitalize as _capitalize
} from "lodash";

const advocatePayloadContext = `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_PAYLOAD}`;
const formValuesContext = `${STATE.SCOPE_FORMS}/${STATE.FORM_VALUES}`;
const validationErrorMsgContext = `${STATE.SCOPE_CAC}/${
  STATE.VALIDATION_ERROR_MSG
}`;
const privacyPolicyUrlContext = `${STATE.SCOPE_CAMPAIGN}/${
  STATE.PRIVACY_POLICY_URL
}`;

const hasAdvocateContext = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;
const advocateRecordContext = `${STATE.SCOPE_FORMS}/${STATE.ADVOCATE_RECORD}`;
const startFillingFormContext = `${STATE.SCOPE_FORMS}/${
  STATE.STARTED_FILLING_FORM
}`;

const optionalFieldsContext = `${STATE.SCOPE_FORMS}/${STATE.OPTIONAL_FIELDS}`;
const customFieldsContext = `${STATE.SCOPE_FORMS}/${STATE.CUSTOM_FIELDS}`;
const showSubscribeEmailContext = `${STATE.SCOPE_FORMS}/${
  STATE.SHOW_SUBSCRIBE_EMAIL
}`;
const showSubscribeSMSContext = `${STATE.SCOPE_FORMS}/${
  STATE.SHOW_SUBSCRIBE_SMS
}`;

export default {
  name: "PersonalInformation",
  components: {
    CacSelect,
    CacInputWrapper,
    CustomFields,
    AdvocateBadge
  },
  mixins: [SharedMixin, GoogleMapsAutocompleteMixin],
  props: {
    showSubscribeCheckboxes: {
      type: Boolean,
      default: true
    },
    selectedRegistrationOption: {
      type: String,
      default: HOME_BUTTON_LABELS.NO,
      validator(value) {
        // state must match one of these strings
        return (
          [
            HOME_BUTTON_LABELS.YES,
            HOME_BUTTON_LABELS.NO,
            HOME_BUTTON_LABELS.NOT_SURE
          ].indexOf(value) !== -1
        );
      }
    },
    submitButtonText: {
      type: String,
      default: ""
    }
  },
  inject: {
    apiHelper: { from: "apiHelper" },
    formHelper: { from: "formHelper" },
    $validator: { from: "$validator" }
  },
  data() {
    return {
      registerBtnDisabled: true,
      loading: false,
      RouteNames
    };
  },
  computed: {
    ...mapGetters({
      advocatePayload: advocatePayloadContext,
      formValues: formValuesContext,
      validationErrorMsg: validationErrorMsgContext,
      hasAdvocate: hasAdvocateContext,
      advocateRecord: advocateRecordContext,
      customFields: customFieldsContext,
      optionalFields: optionalFieldsContext,
      privacyPolicyUrl: privacyPolicyUrlContext,
      showSubscribeEmail: showSubscribeEmailContext,
      showSubscribeSMS: showSubscribeSMSContext
    }),
    ...mapState(STATE.SCOPE_CAC, {
      advocateShortUrlId: STATE.ADVOCATE_SHORTURL_ID
    }),
    ...mapState(STATE.SCOPE_CAMPAIGN, {
      formFields: state =>
        state.formFields.default ? state.formFields.default.welcome : {},
      p2aSourceId: STATE.P2A_SOURCE_ID,
      privacyPolicyUrlLabelText: state => state.privacyPolicyUrlLabel
    }),
    ...mapState(STATE.SCOPE_FORMS, {
      addressAutocomplete: state => state.addressAutocomplete,
      error: state => state.error,
      formValues: state => state.formValues,
      honeypotPageLoadTime: state => state.honeypotPageLoadTime,
      validationResults: state => state.validationResults
    }),
    fieldGroupTag() {
      return "div";
    },
    validationResultsArray() {
      return _compact(_values(this.validationResults.default));
    },
    hasError() {
      return !_isEmpty(this.validationResultsArray) || this.loading;
    },
    honeypotZipcode: {
      get() {
        return this.formValues.zipcode || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "zipcode", value });
      }
    },
    honeypotAddress: {
      get() {
        return this.formValues.address || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "address", value });
      }
    },
    title: {
      get() {
        return this.formValues.title || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "title", value });
      }
    },
    firstName: {
      get() {
        return this.formValues.firstName || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "firstName", value });
      }
    },
    lastName: {
      get() {
        return this.formValues.lastName || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "lastName", value });
      }
    },
    suffix: {
      get() {
        return this.formValues.suffix || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "suffix", value });
      }
    },
    address: {
      get() {
        return this.formValues.address1 || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "address1", value });
      }
    },
    zip: {
      get() {
        return this.formValues.zip5 || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "zip5", value });
      }
    },
    email: {
      get() {
        return this.formValues.email || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "email", value });
      }
    },
    phone: {
      get() {
        return this.formValues.phone || "";
      },
      set(value) {
        this.setFormValue({ fieldName: "phone", value });
      }
    },
    privacyPolicyUrlLabel() {
      return !_isEmpty(this.privacyPolicyUrlLabelText)
        ? this.privacyPolicyUrlLabelText
        : this.$t("cac.app.privacy_policy");
    },
    subscribeEmail: {
      get() {
        return this.formValues.subscribeEmail;
      },
      set(value) {
        this.setFormValue({ fieldName: "subscribeEmail", value });
      }
    },
    subscribeSms: {
      get() {
        return this.formValues.subscribeSms;
      },
      set(value) {
        this.setFormValue({ fieldName: "subscribeSms", value });
      }
    },
    suffixOptions() {
      return [
        {
          value: null,
          label: "--"
        },
        {
          value: "Jr.",
          label: this.$t("cac.app.suffixes.Jr")
        },
        {
          value: "Sr.",
          label: this.$t("cac.app.suffixes.Sr")
        },
        {
          value: "II",
          label: this.$t("cac.app.suffixes.II")
        },
        {
          value: "III",
          label: this.$t("cac.app.suffixes.III")
        },
        {
          value: "IV",
          label: this.$t("cac.app.suffixes.IV")
        }
      ];
    },
    titleOptions() {
      // find available titles as some languages do not have
      // equivalent titles (such as "Ms." in Spanish)
      const { locale, messages } = this.$i18n;
      const { titles } = messages[locale].cac.app;

      return Object.entries(titles).map(([value, label]) => ({
        value,
        label
      }));
    },
    registrationOptions() {
      return [
        {
          optionLabel: HOME_BUTTON_LABELS.YES,
          btnText: this.$t("cac.app.view_voter_information"),
          redirectRoute: RouteNames.VOTER_INFORMATION
        },
        {
          optionLabel: HOME_BUTTON_LABELS.NO,
          btnText: this.$t("cac.app.register_to_vote_btn"),
          redirectRoute: RouteNames.REGISTER_TO_VOTE
        },
        {
          optionLabel: HOME_BUTTON_LABELS.NOT_SURE,
          btnText: this.$t("cac.app.check_registration_status"),
          redirectRoute: RouteNames.REGISTER_TO_VOTE
        }
      ];
    },
    registerBtnText() {
      if (!_isEmpty(this.submitButtonText)) {
        return this.submitButtonText;
      }

      const { btnText } = this.getSelectedOption();
      return btnText;
    },
    showAdvocateBadge() {
      return this.hasAdvocate && this.isHomePage;
    },
    isHomePage() {
      return this.$route.name === RouteNames.HOME;
    }
  },
  async created() {
    this.initFormValidation();
    this.getCustomFields();
    await this.fillInitialAdvInfo();
  },
  methods: {
    ...mapActions({
      setCustomFields: customFieldsContext,
      setFormValue: formValuesContext,
      setValidationErrorMsg: validationErrorMsgContext,
      startFillingForm: startFillingFormContext
    }),
    delayAddressBlurField() {
      // Since the address field needs a few milliseconds to update (the value from Google Maps Autocomplete needs to be applied)
      // We wait a few seconds before validating, so that `this.address` can update
      setTimeout(() => {
        this.detectedManualChange('address1', this.address);
        this.handleFormFieldValue(this.formFields.address1, this.address);
      }, PersonalInformation.ADDRESS_BLUR_FIELD_DELAY);
    },
    async blurField(field, $event, isManual = false) {
      if (isManual) {
        this.detectedManualChange(field.name, $event.target.value);
      }
      
      await this.handleFormFieldValue(field, $event.target.value);
    },
    detectedManualChange(fieldName, fieldValue) {
      const isInputAddressField = (fieldName === 'zip5' || fieldName === 'address1');
      const isGeocodedAddress = this.addressData.lat !== null && this.addressData.lon !== null;
      const lastFieldValue = fieldName === 'address1' ?
        `${this.addressData.streetNum} ${this.addressData.streetName}` :
        this.addressData[fieldName];
      const isAddressChanged = lastFieldValue !== fieldValue;
      
      if (isInputAddressField && isGeocodedAddress && isAddressChanged) {
        this.purgeGeocodedAddressData();
      }
    },
    purgeGeocodedAddressData() {
      this.addressData.lat = null;
      this.addressData.lon = null;
      this.addressData.state = null;
      this.addressData.city = null;
      this.addressData.county = null;
      this.addressData.zip4 = null;
    },
    async handleFormValidation() {
      const formFields = Object.values(this.formFields);

      await Promise.all(
        formFields.map(field =>
          this.handleFormFieldValue(field, this.formHelper.getFieldValue(field))
        )
      );
    },
    async handleFormFieldValue(field, value) {
      this.setValidationErrorMsg({});
      await ValidationHelper.handleFormFieldValue(this, field, value);
    },
    handleDevices(advocatePayload) {
      // If we are hiding the email or phone opt-in checkboxes, we need to make sure that the advocate is not accidentally
      // subscribed; this will not unsubscribe advocates who already signed up for email/text notifications
      if (advocatePayload.devices.email && !this.showSubscribeEmail) {
        advocatePayload.devices.email.subscribed = false;
      }
      if (advocatePayload.devices.phone && !this.showSubscribeSMS) {
        advocatePayload.devices.phone.subscribed = false;
      }
      return ValidationHelper.normalizeAdvocatePhone(advocatePayload);
    },
    getAdvocatePayload() {
      let advocatePayload = {
        ...this.advocatePayload,
        p2aSourceId: this.p2aSourceId,
        advocateShortUrlId: this.advocateShortUrlId
      };
      const keys = [
        'county',
        'country',
        'state',
        'city',
        'zip4',
        'lat',
        'lon'
      ];
      
      keys.forEach(key => {
        if (this.addressData[key]) {
          advocatePayload.address[key] = this.addressData[key];
        }
      });
      
      return this.handleDevices(advocatePayload);
    },
    getSelectedOption() {
      return this.registrationOptions.find(
        option => option.optionLabel === this.selectedRegistrationOption
      );
    },
    async submitInformation() {
      this.trackMixpanelInteract();
      try {
        await this.handleFormValidation();
        if (!this.hasError) {
          this.loading = true;
          const advocatePayload = this.getAdvocatePayload();
          const advocate = await this.apiHelper.postAdvocate(advocatePayload);
          // if backend validation fails in saving the advocate record,
          // throw error which will be displayed on the screen
          if (advocate.error) {
            const errorMsg = _values(advocate.error.response.data);
            throw errorMsg;
          }

          const { redirectRoute } = this.getSelectedOption();
          this.$router.push({ name: redirectRoute });
        }
        this.loading = false;
      } catch (e) {
        this.setValidationErrorMsg([this.$t("app.unknown_error_message")]);
        this.loading = false;
      }
    },
    getCustomAdvocatePayload() {
      const { firstname, lastname, address1, zip5 } = this.advocateRecord;
      return {
        firstname,
        lastname,
        address1,
        zip5
      };
    },
    async fillInitialAdvInfo() {
      if (_isEmpty(this.advocateRecord)) {
        return;
      }

      if (
        this.advocateRecord.fullname &&
        (!this.advocateRecord.firstname && !this.advocateRecord.lastname)
      ) {
        const nameComponents = this.advocateRecord.fullname.split(" ");
        this.advocateRecord.firstname = _capitalize(nameComponents[0]);
        if (nameComponents.length > 1) {
          this.advocateRecord.lastname = _capitalize(
            nameComponents.slice(-1)[0]
          );
        }
      }

      for await (let field of Object.values(this.formFields)) {
        const { name } = field;

        if (name !== undefined) {
          let value = this.advocateRecord[name.toLowerCase()];

          if (name === "phone") {
            // sometimes we return phone numbers in a format that the validator isn't expecting (+11234567890)
            value = this.advocateRecord.phone;
            if (value && value.length > 10 && value.indexOf("+") === 0) {
              value = value.substr(2);
            }
          } else if (name === "title" || name === "suffix") {
            // check to see if input values are in list of options for select fields
            if (
              field.options.filter(option => option.value === value).length ===
              0
            ) {
              value = "";
            }
          }

          if (!_isEmpty(value)) {
            await this.handleFormFieldValue(field, value);
          }
        }
      }
    },
    initFormValidation() {
      this.updateZipValidationMsg();
      this.validatorHelper = new VueValidatorHelper(this.formFields);
      this.validatorHelper.setValidator(this.$validator);
    },
    updateZipValidationMsg() {
      const errorMsg = this.formHelper.getZipFieldValidationError(
        this.formFields.zip5.validationRules.required
      );
      this.formFields.zip5.validationRules.required = errorMsg;
      this.formFields.zip5.validationRules["max:10|digits:5"] = errorMsg;
    },
    getCustomFields() {
      const customFields = this.formHelper.getCustomFields(this.formFields);
      this.setCustomFields(customFields);
    }
  }
};
</script>
